export const PRODUCT_STATUS = Object.freeze({
    PENDING: 0,
    APPROVED: 1,
    REJECTED: 2,
    SOLD_OUT: 3,
    AUCTION: 5,
    BID_ACCEPT: 6,
    BID_REJECT: 7,
    PROCESS: 8,
    PAID: 9,
    SHIP: 10,
    RECEIVE: 11,
    CLOSE: 12,
  });

  export const getStatusString = (status) => {
    const statusMap = {
      [PRODUCT_STATUS.PENDING]: "Pending",
      [PRODUCT_STATUS.APPROVED]: "Approved",
      [PRODUCT_STATUS.REJECTED]: "Rejected",  
      [PRODUCT_STATUS.AUCTION]: "Auction",  
      [PRODUCT_STATUS.BID_ACCEPT]: "Bid accepted",  
      [PRODUCT_STATUS.BID_REJECT]: "Bid rejected",  
      [PRODUCT_STATUS.PAID]: "Paid",  
      [PRODUCT_STATUS.PROCESS]: "Process",  
      [PRODUCT_STATUS.SHIP]: "Shipped",  
      [PRODUCT_STATUS.RECEIVE]: "Received",  
      [PRODUCT_STATUS.CLOSE]: "Closed",  
    };
    return statusMap[status] || "Unknown Status";
  };

// export const getStatusString = (status) => {
//     const statusMap = {
//       0: "Pending",
//       1: "Approved",
//       2: "Rejected",   
//     };
//     return statusMap[status] || "Unknown Status";
// };